<script>
export default {
  name: 'EmptyLayout'
}
</script>

<template>
  <div class="empty-layout">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.empty-layout {
	background-color: #fff;
	padding: 1rem;
	min-height: 100vh;

	@media print {
		padding: 0;
	}
}
</style>
